import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import themeStyles from './DonutChart.styles';
import DonutChartUi from './DonutChartUi';
import { DonutChartMaxSections } from '../utils';
const DonutChart = ({ fields }) => {
    if (!fields) {
        return null;
    }
    const { chartTitle, ...rest } = fields;
    const donutDataArray = [];
    // build the data array for donut chart in the format that is expected by recharts utility
    for (let i = 0; i <= DonutChartMaxSections; i++) {
        if (rest[`chartLabel${i + 1}`] && rest[`chartValue${i + 1}`]) {
            const name = rest[`chartLabel${i + 1}`];
            const value = rest[`chartValue${i + 1}`];
            const color = rest[`chartColor${i + 1}`];
            const nameValue = (name === null || name === void 0 ? void 0 : name.value) || '';
            const valueStr = (value === null || value === void 0 ? void 0 : value.value) || '';
            const colorValue = (color === null || color === void 0 ? void 0 : color.value) || '';
            if (nameValue !== '' && valueStr !== '' && colorValue !== '') {
                const parsedValue = parseFloat(valueStr.toString());
                if (!Number.isNaN(parsedValue) && parsedValue >= 0) {
                    donutDataArray.push({
                        name: name === null || name === void 0 ? void 0 : name.value,
                        value: parseFloat(value === null || value === void 0 ? void 0 : value.value),
                        color: color === null || color === void 0 ? void 0 : color.value,
                    });
                }
            }
        }
    }
    const GraphicContainer = themeStyles.apply('div', 'GraphicContainer');
    return (_jsx(GraphicContainer, { "data-testid": "graphic-container", children: _jsx(DonutChartUi, { chartData: donutDataArray, chartTitle: chartTitle === null || chartTitle === void 0 ? void 0 : chartTitle.value }) }));
};
export default DonutChart;
